import React, { useState } from 'react';
import { authAPI } from '../services/api';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';
import AuthLayout from '../components/AuthLayout';
import PasswordInput from '../components/PasswordInput';
import LicenseActivationPanel from '../components/LicenseActivationPanel';
import { useAppSettings } from '../context/AppSettingsContext';

const Login = ({ onLogin }) => {
  const { appName } = useAppSettings();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        username: credentials.username.trim(),
        password: credentials.password
      };
      const response = await authAPI.login(payload);
      if (response.data.success) {
        const user = response.data.data.user;
        const token = response.data.data.token;

        if (user?.force_password_change) {
          toast.info('Password change is required before continuing.');
        } else {
          toast.success('Login successful!');
        }
        onLogin(user, token);
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Login failed';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <h2>Welcome back</h2>
      <p className="text-center text-muted mb-3">Sign in to continue to {appName}</p>

      <LicenseActivationPanel />

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            placeholder="Username"
            value={credentials.username}
            onChange={(e) => setCredentials({...credentials, username: e.target.value})}
            required
            autoFocus
          />
        </div>
        <div className="form-group">
          <PasswordInput
            placeholder="Password"
            value={credentials.password}
            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
            autoComplete="current-password"
            required
          />
        </div>
        <div style={{ textAlign: 'right', marginTop: '-0.5rem', marginBottom: '1rem' }}>
          <Link to="/forgot-password" style={{ fontSize: 'var(--fs-md)', color: 'var(--primary-color)', textDecoration: 'none' }}>Forgot Password?</Link>
        </div>
        <button type="submit" className="btn btn-primary w-full" disabled={loading}>
          {loading ? 'Logging in...' : 'Sign In'}
        </button>
      </form>
      <div className="login-compliance-badge">
        <FaCheckCircle /> <span>21 CFR Part 11 Compliant &nbsp;|&nbsp; {appName} v1.0</span>
      </div>
    </AuthLayout>
  );
};

export default Login;
